import {Button, Result} from 'antd';
import React, {useEffect, useState} from 'react';
import {history} from 'umi';
import {FormApi} from "@/services/sales";

const AccessDenyPage: React.FC<{ subTitle?: string }> = (props) => (
  <Result
    status="403"
    title="403"
    subTitle={
      <div>
        {props?.subTitle || "您没有权限访问该页面"}
        <div style={{marginTop: 12}}>
          TPM没有权限，需要在OA走“业务应用系统权限职责申请”申请权限，如有疑问请联系相关业务顾问
        </div>
      </div>
    }
    extra={
      <Button type="primary" onClick={() => history.push('/')}>返回首页</Button>
    }
  />
);

export default AccessDenyPage;

export const OpenWithAccessPage: React.FC<{ formId: number }> = (props) => {
  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {
    FormApi.doesAccess(props.formId).then((res) => {
      setCanAccess(res.data);
    })
  }, []);
  if (!canAccess) {
    return <AccessDenyPage subTitle={`您无权查看页面`}></AccessDenyPage>;
  }
  return (
    <>
      {props.children}
    </>
  )
};
